import { renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, Transition as _Transition, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f7b87e16")

_pushScopeId("data-v-f7b87e16")
const _hoisted_1 = { class: "wrapper hg_114 " }
const _hoisted_2 = { class: "user_info" }
const _hoisted_3 = {
  key: 0,
  class: "not_login_avatar"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "content_wrap" }
const _hoisted_6 = { class: "user_name" }
const _hoisted_7 = { class: "text_wrap flex_start_center" }
const _hoisted_8 = { class: "head_text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_UserInfoDetail = _resolveComponent("UserInfoDetail")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default", {}, undefined, true),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: "avatar_wrap",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openUserDetail && _ctx.openUserDetail(...args)))
      }, [
        (!_ctx.viewModel.isLogin || !_ctx.viewModel.avatar)
          ? (_openBlock(), _createBlock("div", _hoisted_3))
          : (_openBlock(), _createBlock("div", _hoisted_4, [
              _createVNode("img", {
                src: _ctx.viewModel.avatar,
                class: "avatar",
                onError: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.errorImg && _ctx.errorImg(...args)))
              }, null, 40, ["src"]),
              _createVNode("span", {
                class: ["avatar_icon", { is_vip: _ctx.viewModel.isVip }]
              }, null, 2)
            ]))
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          _createVNode("span", null, _toDisplayString(_ctx.viewModel.isLogin ? _ctx.viewModel.nickname : "未登录"), 1),
          (_ctx.viewModel.isLogin)
            ? (_openBlock(), _createBlock("span", {
                key: 0,
                class: ["login_icon", _ctx.loginTypeClass]
              }, null, 2))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("span", _hoisted_8, _toDisplayString(_ctx.headText), 1),
          (_ctx.viewModel.isSingleNormalMember)
            ? (_openBlock(), _createBlock("button", {
                key: 0,
                class: "common_btn renew_btn",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.clickRenew && _ctx.clickRenew(...args)))
              }, " 续费 "))
            : _createCommentVNode("", true)
        ])
      ]),
      (!_ctx.viewModel.isLogin)
        ? (_openBlock(), _createBlock("button", {
            key: 0,
            class: "common_btn login_btn",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.clickLogin && _ctx.clickLogin(...args)))
          }, " 立即登录 "))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withId(() => [
        (_ctx.viewModel.detailVisible)
          ? (_openBlock(), _createBlock(_component_UserInfoDetail, {
              key: 0,
              onSuccess: _ctx.modalSuccess,
              onCancel: _ctx.modalCancel
            }, null, 8, ["onSuccess", "onCancel"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
})